const licencia = {
  readLicenciasUsuario: 'licencias'
}

export default licencia
